import { Route, Routes, useNavigate } from 'react-router-dom';

import App from './App';
import AppAgent from './AppAgent';

export default function Root() {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route index element={<App navigate={navigate} />} />
      <Route path="/agent" element={<AppAgent />} />
    </Routes>
  );
}
